import React from 'react';
import { getConfiguration, getStatsUrl } from '../data/utils';
import { STATSCORE_WIDGET_PREMATCH_PRO, getStatsCoreConfigurationId } from '../data/widgets/WidgetContext';
import PrematchProToggle from '../prematch/widgets/PrematchProToggle';

export default function StatsToggle(props) {
    const prematchProEnabled = getStatsCoreConfigurationId(STATSCORE_WIDGET_PREMATCH_PRO) != null;
    const match = props.match;

    if (prematchProEnabled) {
        const id = match.lsportWidgetId;
        if (id != null && id > 0) {
            return (
                <PrematchProToggle className={props.className} id={match.lsportWidgetId} />
            );
        }
    } else if (match.id && match.id >= 0) {
        let statsUrl = null;

        const conf = getConfiguration();
        if (conf.ps?.asum) {
            const tournamentUniqueId = `${match.sportRef}_${match.categoryRef}_${match.tournamentRef}`;
            const altUrl = conf.ps.asum[tournamentUniqueId];
            if (altUrl != null) {
                statsUrl = altUrl.replace('{{MATCH_ID}}', match.id);
            }
        }

        if (statsUrl == null) {
            statsUrl = getStatsUrl(match.id);
        }

        if (statsUrl?.length > 0) {
            return (
                <i key={match.id} className={props.className} data-stats-url={statsUrl} ></i>
            );
        }
    }

    return null;
}
